module.exports = __webpack_public_path__ + "img/gift3.e4d7b5c4.png";